import { render, staticRenderFns } from "./select-address.vue?vue&type=template&id=056e1717&scoped=true"
import script from "./select-address.vue?vue&type=script&lang=js"
export * from "./select-address.vue?vue&type=script&lang=js"
import style0 from "./select-address.vue?vue&type=style&index=0&id=056e1717&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056e1717",
  null
  
)

export default component.exports